import React, { Component } from "react";
import { Link } from 'react-router-dom'

export default class UsersMassive extends Component {

  constructor(props) {
    super(props);
    this.state = {
      user    : JSON.parse(localStorage.getItem('tpuser')),
      text    : '',
      error   : false,
      success : false
    };

    // Fast redirection?
    if(!this.state.user || this.state.user.role != 'admin')
      window.location.replace('/login');

    // Bindings
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {}

  handleChange(e){
    const state = this.state;
    state[e.target.name] = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    this.setState(state);
  }

  handleSubmit(e){
    e.preventDefault();

    if( this.state.text.length < 1 )
      return alert('Campo de texto vacío.');

    let rows = this.state.text.split("\n").map( r => {

      r = r.split(',');
      if( r.length < 7 )
        return alert('Datos mal formateados.');

      let name      = r[0].trim();
      let lastname  = r[1].trim();
      let rut       = r[2].trim();
      let dv        = r[3].trim();
      let password  = rut.substr(0,4).trim();
      let sex       = r[4].trim();
      let school    = r[5].trim();
      let grade     = r[6].trim();

      return {name, lastname, rut, dv, password, sex, school, grade};

    });
    this.loadItems(rows);
  }

  loadItems(items){
    fetch(process.env.REACT_APP_API_URL + '/users', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + this.state.user.token
      },
      body: JSON.stringify({ users: items })
    }).then((response) => {
      return response.json();
    })
    .then((data) => {
      //console.log('data', data);
      if(data.error) this.setState({ error: true, success: false });
      else this.setState({ error: false, success: true });
    });
  }

  render() {

    const errorAlert   = this.state.error && <div className="alert alert-danger">Hubo un error al cargar.</div>
    const successAlert = this.state.success && <div className="alert alert-success">Carga realizada con éxito.</div>

    return (
      <div className="container">
        <div className="row">
          <div className="col-sm-3">

            <h5>Instrucciones</h5>
            <ol>
              <li>Ingrese el contenido de sus usuarios, uno en cada línea.<br/><br/></li>
              <li>Los datos de cada usuario deben estar separados por coma y en el orden indicado en el area de texto a la derecha.<br/><br/></li>
              <li>Envíe los datos haciendo click en el botón "Cargar".<br/><br/></li>
            </ol>

          </div>
          <form className="col-sm-9">

            { errorAlert }
            { successAlert }

            <h5>Carga masiva</h5>
            <textarea name="text" className="form-control" rows="15" onChange={this.handleChange} placeholder="nombre, apellido, rut, dv, genero, rbd, curso"></textarea>
            <button className="btn btn-primary btn-lg" onClick={this.handleSubmit}>Cargar</button>
          </form>
        </div>
      </div>
    );

  }
}


// WEBPACK FOOTER //
// ./src/admin/UsersMassive.jsx